import { formatMonthLabel } from '@/lib/format';

interface MonthNavigatorProps {
  mes: string;
  onChange: (mes: string) => void;
  onPrev: () => void;
  onNext: () => void;
}

export function MonthNavigator({ mes, onPrev, onNext }: MonthNavigatorProps) {
  const arrow =
    'flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-lg text-conduril-muted transition hover:bg-conduril-surface hover:text-conduril';

  return (
    <div className="flex items-center gap-2 rounded-xl border border-conduril-border bg-white px-1.5 py-1.5 shadow-card">
      <button type="button" onClick={onPrev} aria-label="previous month" className={arrow}>
        ‹
      </button>
      <div className="min-w-0 flex-1 text-center text-sm font-semibold capitalize text-conduril-ink">
        {formatMonthLabel(mes)}
      </div>
      <button type="button" onClick={onNext} aria-label="next month" className={arrow}>
        ›
      </button>
    </div>
  );
}
